"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _sbUtils = require("@simplybenefits/sb-utils");
var Services = _interopRequireWildcard(require("../../../services"));
var _Text = _interopRequireDefault(require("../../../components/Text"));
var _Button = _interopRequireDefault(require("../../../components/Button"));
var _ClassListItem = _interopRequireDefault(require("./ClassListItem"));
var _ContainerControlSite = _interopRequireDefault(require("../../../components/Divs/ContainerControlSite"));
var _theme = require("../../../theme");
var _RateTable = _interopRequireDefault(require("./RateTable"));
var _i18n = _interopRequireDefault(require("../../../localization/i18n"));
var _tokens = _interopRequireDefault(require("../../../localization/tokens"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Pricing = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(Pricing, _Component);
  function Pricing() {
    var _this;
    (0, _classCallCheck2["default"])(this, Pricing);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (0, _possibleConstructorReturn2["default"])(_this, (_this = _callSuper(this, Pricing, [].concat(args)), _this.state = {
      selectedClass: null,
      classIds: [],
      pricing: null
    }, _this._selectClass = function (value) {
      _this.setState({
        selectedClass: value,
        pricing: _this.props.designs[value][_this.props.classData[value].planDesignID].pricing
      });
    }, (0, _assertThisInitialized2["default"])(_this)));
  }
  (0, _createClass2["default"])(Pricing, [{
    key: "_findFirstValidClassDesign",
    value: function _findFirstValidClassDesign(classDesigns) {
      // Iterate through the object entries to find the first valid class design
      for (var _i = 0, _Object$entries = Object.entries(classDesigns); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = (0, _slicedToArray2["default"])(_Object$entries[_i], 2),
          classID = _Object$entries$_i[0],
          classDesign = _Object$entries$_i[1];
        if (classDesign.planDesignID !== null) {
          // Return the first valid class design
          return classID;
        }
      }

      // Return null if no valid class design is found
      return null;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var classIds = _sbUtils.helpers.sortObjByTitle(this.props.classData);
      var firstValidClassID = this._findFirstValidClassDesign(this.props.classData);
      this.setState({
        classIds: (0, _toConsumableArray2["default"])(classIds),
        selectedClass: firstValidClassID,
        pricing: this.props.designs[firstValidClassID][this.props.classData[firstValidClassID].planDesignID].pricing
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        classData = _this$props.classData,
        currentAccountMeta = _this$props.currentAccountMeta;
      var styles = {
        contentBlock: {
          backgroundColor: _theme.colors.surface,
          boxShadow: '0 1px 2px rgba(0, 0, 0, .15)',
          display: 'block',
          margin: 'auto auto 30px auto',
          padding: '30px',
          position: 'relative',
          zIndex: 3
        },
        downloadBtnContainer: {
          display: 'flex',
          flex: 1,
          justifyContent: 'flex-end',
          marginBottom: 10
        }
      };
      if (!this.state.selectedClass || !this.state.pricing) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement(_ContainerControlSite["default"], null, /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.downloadBtnContainer
      }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        transparent: true,
        onClick: function onClick() {
          return _this2.props.downloadPricingPdf("PlanPricing", "Plan-Pricing.pdf", {
            accountID: currentAccountMeta.accountID
          });
        }
      }, _i18n["default"].t(_tokens["default"].buttons.download))), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        alignItems: "center",
        spacing: 2
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 4,
        sx: {
          paddingBottom: "8px"
        }
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        align: "center",
        mediumLarge: true,
        display: "inline"
      }, _i18n["default"].t(_tokens["default"].titles["class"])))), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        spacing: 2
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 2,
        md: 3
      }, this.state.classIds.map(function (classID, i) {
        // remove mod flex classes that have no plan design, ie parent classes
        if (_this2.props.classData[classID].planDesignID === null) {
          return null;
        }
        return /*#__PURE__*/_react["default"].createElement(_ClassListItem["default"], {
          id: i === 0 ? 'class' : "class-".concat(i),
          key: Services.concatTokens(classID, classData[classID].title),
          data: classData[classID],
          onSelect: function onSelect() {
            return _this2._selectClass(classID);
          },
          selected: _this2.state.selectedClass === classID
        });
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 10,
        md: 9
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.contentBlock
      }, /*#__PURE__*/_react["default"].createElement(_RateTable["default"], {
        pricing: this.state.pricing,
        isAsoDental: currentAccountMeta.isAsoDental,
        isAsoHealth: currentAccountMeta.isAsoHealth
      })))));
    }
  }]);
  return Pricing;
}(_react.Component);
var _default = exports["default"] = Pricing;